<!-- 预提行信息 -->
<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button @click="insertRow()" type="primary" size="medium" class="vxe-btn-primary"
          ><svg-icon
            class="icon-img"
            style="font-size: 16px; padding-right: 6px"
            icon-class="icon-add"
          />新增行</vxe-button
        >
        <vxe-button
          @click="handleDelete('indoundList')"
          type="primary"
          size="medium"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除行</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      v-if="this.accruedInfo.accruedType == 'YT16' || this.accruedInfo.accruedType == 'YT17'"
      border
      show-overflow
      resizable
      ref="indoundList"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :columns="salesListColumn"
      :data="indoundDetailList"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
        activeMethod: activeRowMethod,
      }"
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <vxe-grid
      v-else
      border
      show-overflow
      resizable
      ref="indoundList"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :columns="indoundListColumn"
      :data="indoundDetailList"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
        activeMethod: activeRowMethod,
      }"
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <!-- 新增行详情 -->
    <detail ref="dialog" :accruedInfo="accruedInfo" @confirm="confirm(arguments)" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import API from "@/api/financeCenter/withholding";
  import detail from '../detail';
  // import InputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    components: {
      // InputNumberAd,
      detail,
    },
    props: ['canEdit', 'validateForm', 'accruedInfo'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //入库批次明细行信息
      indoundListColumn() {
        return [
          { type: 'checkbox', width: 50 }, // checkbox
          {
            field: 'inboundNo',
            title: this.$t('withholdingList.column.inboundNo'),
            visible: true,
            width: 120,
          }, //业务入库单号
          {
            field: 'businessInboundBatchNo',
            title: this.$t('withholdingList.column.businessInboundBatchNo'),
            visible: true,
            width: 120,
          }, //业务入库批次号
          {
            field: 'contractNo',
            title: this.$t('withholdingList.withholdInfoAdd.column.contractNo'),
            visible: true,
            width: 120,
          }, //采购合同号
          {
            field: 'contractDetailNo',
            title: this.$t('withholdingList.withholdInfoAdd.column.contractDetailNo'),
            visible: true,
            width: 120,
          }, //采购合同行号
          {
            field: 'inboundQuantity',
            title: this.$t('withholdingList.inboundLine.table.inboundQuantity'),
            visible: true,
            width: 120,
          }, //入库数量
          {
            //预提金额原币
            field: 'accruedAmount',
            title: this.$t('withholdingList.column.accruedAmount'),
            visible: true,
            width: 120,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [<span>{this.$baseRequest.formatTableColumn(row.accruedAmount)}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.accruedAmount}
                      min={-99999999999999999}
                      max={99999999999999999}
                      onInput={(val) => this.chooseSearchTable(row, val, 'accruedAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          },
          {
            //预提金额本币
            field: 'companyAccruedAmount',
            title: this.$t('withholdingList.column.companyAccruedAmount'),
            visible: true,
            width: 120,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [
                    <span>{this.$baseRequest.formatTableColumn(row.companyAccruedAmount)}</span>,
                  ];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.companyAccruedAmount}
                      min={-99999999999999999}
                      max={99999999999999999}
                      onInput={(val) => this.chooseSearchTable(row, val, 'companyAccruedAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          },
          {
            //业务结算单价
            field: 'priceWithTax',
            title: this.$t('withholdingList.column.priceWithTax'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.priceWithTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          {
            //不含税单价
            field: 'priceWithoutTax',
            title: this.$t('withholdingList.column.priceWithoutTax'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.priceWithoutTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          {
            field: 'purePrice',
            title: this.$t('withholdingList.column.purePrice'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.purePrice)}</span>];
              },
            },
            visible: true,
            width: 120,
          }, //业务结算价净值
          {
            //业务结算价含税金额
            field: 'amountWithTax',
            title: this.$t('withholdingList.column.amountWithTax'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.amountWithTax)}</span>];
              },
            },
            visible: true,
            width: 130,
          },
          {
            //业务结算价税额
            field: 'taxAmount',
            title: this.$t('withholdingList.column.taxAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.taxAmount)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          {
            field: 'taxRate',
            title: this.$t('withholdingList.column.taxRate'),
            visible: true,
            width: 100,
          }, //税率
          {
            field: 'storageNo',
            title: this.$t('withholdingList.column.storageNo'),
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageName',
            title: this.$t('withholdingList.column.storageName'),
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'productNo',
            title: this.$t('withholdingList.column.productNo'),
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productDesc',
            title: this.$t('withholdingList.column.productDesc'),
            visible: true,
            width: 120,
          }, //物料描述
        ];
      },
      salesListColumn() {
        return [
          { type: 'checkbox', width: 50 }, // checkbox
          // { field: "customerName",title: this.$t("withholdingList.withholdInfoAdd.salesCloumn.customerName"),visible: true,width:120},//客户
          {
            field: 'inboundNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.ladingNo'),
            visible: true,
            width: 120,
          }, //提单号
          {
            field: 'businessInboundBatchNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.ladingDetailNo'),
            visible: true,
            width: 120,
          }, //提单行号
          {
            field: 'contractNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.contractNo'),
            visible: true,
            width: 120,
          }, //销售合同号
          {
            field: 'contractDetailNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.contractDetailNo'),
            visible: true,
            width: 120,
          }, //销售合同行号
          // { field: "ladingQuantity",title: this.$t("withholdingList.withholdInfoAdd.salesCloumn.ladingQuantity"),visible: true,width:120},//提单数量
          {
            field: 'inboundQuantity',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.actualSendQuantity'),
            visible: true,
            width: 120,
          }, //实发数量
          {
            //预提金额原币
            field: 'accruedAmount',
            title: this.$t('withholdingList.column.accruedAmount'),
            visible: true,
            width: 120,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [<span>{this.$baseRequest.formatTableColumn(row.accruedAmount)}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.accruedAmount}
                      min={-99999999999999999}
                      max={99999999999999999}
                      onInput={(val) => this.chooseSearchTable(row, val, 'accruedAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          },
          {
            //预提金额本币
            field: 'companyAccruedAmount',
            title: this.$t('withholdingList.column.companyAccruedAmount'),
            visible: true,
            width: 120,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [
                    <span>{this.$baseRequest.formatTableColumn(row.companyAccruedAmount)}</span>,
                  ];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.companyAccruedAmount}
                      min={-99999999999999999}
                      max={99999999999999999}
                      onInput={(val) => this.chooseSearchTable(row, val, 'companyAccruedAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          },
          {
            field: 'priceWithTax',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.businessChangingUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.priceWithTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          }, //变动单价
          {
            field: 'amountWithTax',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.businessLadingAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.amountWithTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          }, //业务结算价含税金额/提单金额
          {
            field: 'storageNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.storageNo'),
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageName',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.storageName'),
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'productNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.productNo'),
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productDesc',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.productDesc'),
            visible: true,
            width: 120,
          }, //物料描述
        ];
      },
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.canEdit ? { trigger: 'click', mode: 'row' } : {};
    },
    watch: {
      // 判断表格编辑功能是否禁用
      canEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
    },
    data() {
      return {
        indoundDetailList: [],
      };
    },
    methods: {
      // 初始化数据
      initData(table = []) {
        table.forEach((i) => {
          if (i.taxRateDict) {
            i.taxRate = i.taxRateDict;
            i.currencyName = i.taxRateDict;
          }
        });
        return table;
      },
      // 弹窗确认
      confirm(value) {
        let list = [];
        let selections = value[0];
        let dialogFlag = value[1];
        selections.map((item) => {
          let obj = {
            accruedId: '',
            inboundNo: '',
            businessInboundBatchNo: '',
            inboundQuantity: 0,
            accruedAmount: null,
            companyAccruedAmount: null,
            priceWithTax: 0,
            priceWithoutTax: 0,
            purePrice: 0,
            amountWithTax: null,
            taxAmount: null,
            taxCode: '',
            taxRate: 0,
            storageNo: '',
            storageName: '',
            productNo: '',
            productDesc: '',
            contractNo: '',
            contractDetailNo: '',
            customerName: '',
            ladingQuantity: '',
            // ladingNo:'',ladingDetailNo:'',actualSendQuantity:''
          };

          if (dialogFlag == 'mc') {
            // 委托加工入库单
            obj.inboundNo = item.inboundNo; //业务入库单号/销售提单号
            obj.businessInboundBatchNo = item.inboundBatchNo; //入库批次号/提单行号
            obj.inboundQuantity = item.inboundQuantity; //业务入库数量/实发数量
            obj.priceWithTax = item.businessContractPrice; //业务结算单价 加工费单价
            obj.priceWithoutTax = item.settlementPrice; //业务结算不含税单价 不含税产成品结算价
            obj.amountWithTax = item.mcAmountWithTax; //业务结算价含税金额 含税加工费总金额
            obj.purePrice = item.mcAmountWithoutTax; //业务结算价净值 不含税加工费总金额
            obj.taxAmount = item.mcTaxWithout; //业务结算价税额 加工费税额
            obj.contractNo = item.contractNo; //委托加工合同号
            obj.contractDetailNo = item.contractDetailNo; //合同行号
            obj.taxCode = item.taxCode; //加工费税码
            obj.taxRate = item.taxRate; //加工费税率
            obj.storageNo = item.inboundStorageNo; //转入仓库编码
            obj.storageName = item.inboundStorageName; //转入仓库名称
            obj.productNo = item.productNo; //商品编码
            obj.productDesc = item.productDesc; //商品描述
          } else {
            // 预提类型为出口佣金、出口运费
            if (this.accruedInfo.accruedType == 'YT16' || this.accruedInfo.accruedType == 'YT17') {
              obj.contractNo = item.contractNo; //销售合同号
              obj.customerName = item.customerName; //客户名称
              obj.inboundNo = item.ladingNo; //业务入库单号/销售提单号
              obj.businessInboundBatchNo = item.ladingDetailNo; //入库批次号/提单行号
              obj.ladingQuantity = item.ladingQuantity; //提单数量
              obj.inboundQuantity = item.actualSendQuantity; //业务入库数量/实发数量
              obj.priceWithTax = item.businessChangingUnitPrice; //业务结算单价/变动单价
              obj.amountWithTax = item.businessLadingAmount; //业务结算价含税金额/提单金额
            } else {
              obj.inboundNo = item.businessInboundNo; //业务入库单号/销售提单号
              obj.businessInboundBatchNo = item.businessInboundBatchNo; //入库批次号/提单行号
              obj.inboundQuantity = item.inboundQuantity; //业务入库数量/实发数量
              obj.priceWithTax = item.businessVariablePrice; //业务结算单价/变动单价
              obj.priceWithoutTax = item.businessVariablePriceWithoutTax; //业务结算不含税单价
              obj.amountWithTax = item.businessVariablePriceWithTax; //业务结算价含税金额/提单金额
              obj.purePrice = item.businessVariablePricePureAmount; //业务结算价净值
              obj.taxAmount = item.businessVariablePriceTaxAmount; //业务结算价税额
            }
            obj.contractNo = item.contractNo; //销售合同号
            obj.contractDetailNo = item.contractDetailNo; //合同号
            obj.taxCode = item.taxCode; //税码
            obj.taxRate = item.taxRate; //税率
            obj.storageNo = item.storageNo; //仓库编码
            obj.storageName = item.storageName; //仓库名称
            obj.productNo = item.productNo; //商品编码
            obj.productDesc = item.productDesc; //商品描述
          }
          obj = this.$baseRequest.assignObj(obj);
          list.push(obj);
        });
        let detailList = this.$refs.indoundList.getTableData().fullData;
        // if(!detailList||!detailList[0]){
        //   this.accruedInfo.detailList = [];
        // }
        let flag = false;
        list.map((par) => {
          detailList.map((item) => {
            if (this.accruedInfo.accruedType == 'YT16' || this.accruedInfo.accruedType == 'YT17') {
              if (
                item.businessInboundBatchNo == par.businessInboundBatchNo &&
                item.inboundNo == par.inboundNo
              ) {
                flag = true;
              }
            } else {
              if (item.businessInboundBatchNo == par.businessInboundBatchNo) {
                flag = true;
              }
            }
          });
        });
        if (flag) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '所选的业务入库明细数据不能重复，请检查！',
          });
        }
        // 预提金额原币与预提金额本币计算
        this.upTableData([...detailList, ...list]);
      },
      activeRowMethod() {
        //禁用编辑
        return this.canEdit;
      },
      // 新增行弹框
      async insertRow() {
        let params = {
          contractNo: this.accruedInfo.contractNo,
        };
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        this.$refs.dialog.openDialog(params);
      },
      // 表格删除
      handleDelete(tableName) {
        const selectedList = this.$refs[tableName].getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('receivablesManage.message.deleteSuccess'),
            });
            this.$refs[tableName].removeSelecteds();
            // 预提金额原币与预提金额本币计算
            this.upTableData([...this.$refs[tableName].getTableData().fullData]);
          })
          .catch(() => {
            /* this.$message({
          showClose: true,
          type: "info",
          message: this.$t('receivablesManage.message.cancelled')
        }); */
          });
      },
      chooseSearchTable(row, val, type) {
        row[type] = val;
        this.$refs.indoundList.updateFooter();
      },
      //预提原币，本币金额更新
      upTableData(detailList) {
        let inboundQuantitySum = 0; //入库数量合计
        detailList.map((item) => {
          inboundQuantitySum = inboundQuantitySum + item.inboundQuantity;
        });
        let restAccruedAmount = this.accruedInfo.accruedWithoutTaxAmount;
        let restCompanyAccruedAmount = this.accruedInfo.companyAccruedWithoutTaxAmount;
        detailList.map((item, index) => {
          if (index == detailList.length - 1) {
            item.accruedAmount = restAccruedAmount;
            item.companyAccruedAmount = restCompanyAccruedAmount;
          } else {
            item.accruedAmount = this.$cal.calCommon(
              this.$cal.calCommon(
                this.accruedInfo.accruedWithoutTaxAmount,
                item.inboundQuantity,
                '*'
              ),
              inboundQuantitySum,
              '/',
              'amount'
            );
            item.companyAccruedAmount = this.$cal.calCommon(
              this.$cal.calCommon(
                this.accruedInfo.companyAccruedWithoutTaxAmount,
                item.inboundQuantity,
                '*'
              ),
              inboundQuantitySum,
              '/',
              'amount'
            );
          }
          restAccruedAmount = this.$cal.calCommon(restAccruedAmount, item.accruedAmount, '-');
          restCompanyAccruedAmount = this.$cal.calCommon(
            restCompanyAccruedAmount,
            item.companyAccruedAmount,
            '-'
          );
        });
        this.indoundDetailList = detailList;
        this.$refs.indoundList.updateFooter();
      },
      // 合计
      footerMethod({ columns, data }) {
        let returnProps = [
          'accruedAmount', //预提金额原币
          'companyAccruedAmount', //预提金额本币
          // 'priceWithTax',//业务结算单价
          // 'priceWithoutTax',//不含税单价
          // 'purePrice',//业务结算价净值
          // 'amountWithTax',//业务结算价含税金额
          // 'taxAmount',//业务结算价税额
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('withholdingList.fundsInterests.sumName');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
